import axios from "@/plugins/axios";
export default {
  create: (data) =>
    axios
      .post(`/point-of-sales/generator`, data)
      .then((response) => response.data),
  update: (data, id) =>
    axios
      .post(`/point-of-sales/generator/${id}`, data)
      .then((response) => response.data),
  show: (id) =>
    axios
      .get(`/point-of-sales/generator/${id}`)
      .then((response) => response.data),
};
